import {
	projectPendingKey,
	projectApprovedKey,
	projectRejectedKey,
	projectDeliveryRejectedKey,
	projectAcceptedKey,
	projectCreatorRejectedKey,
	projectAllCreatorsRejectedKey,
	projectDeliveryPendingKey,
	projectDeliveredKey,
} from 'root/src/shared/constants/keys'

export default {
	type: 'object',
	properties: {
		id: { type: 'string' },
		creator: { type: 'string' },
		title: { type: 'string' },
		description: { type: 'string' },
		pledgeAmount: { type: 'number' },
		brandProduct: {
			type: 'object',
			properties: {
				productName: { type: 'string' },
				url: { type: 'string' },
				cta: { type: 'string' },
			},
		},
		sponsor: {
			type: 'object',
			properties: {
				brandName: { type: 'string' },
				brandWebsite: { type: 'string' },
				brandLogo: { type: 'object' },
			},
		},
		// PLEDGER IS FOR PANEL OBFUSCATION
		pledger: {
			type: 'object',
			properties: {
				url: { type: 'string' },
				img: { type: 'string' },
				name: { type: 'string' },
				text: { type: 'string' },
			},
		},
		// ITEM IS FOR PANEL OBFUSCATION
		item: {
			type: 'object',
			properties: {
				heading: { type: 'string' },
				name: { type: 'string' },
				url: { type: 'string' },
			},
		},
		creatorData: {
			type: 'object',
			properties: {
				twitchId: { type: 'string' },
				displayName: { type: 'string' },
				img: { type: 'string' },
			},
		},
		status: {
			type: 'string',
			enum: [
				projectPendingKey,
				projectApprovedKey,
				projectRejectedKey,
				projectDeliveryRejectedKey,
				projectAcceptedKey,
				projectCreatorRejectedKey,
				projectAllCreatorsRejectedKey,
				projectDeliveryPendingKey,
				projectDeliveredKey,
			],
		},
		assignees: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					platform: {
						type: 'string',
						enum: ['twitch', 'youtube', 'tiktok'],
					},
					image: { type: 'string' },
					description: { type: 'string' },
					platformId: { type: 'string' },
					displayName: { type: 'string' },
					amountRequested: { type: 'number' },
					username: { type: 'string' },
					accepted: { type: 'string' },
				},
				required: ['platform', 'image', 'platformId'],
			},
		},
		games: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					name: { type: 'string' },
					boxArtTemplateUrl: { type: 'string' },
					id: { type: 'string' },
					mobile: { type: 'string' },
					desktop: { type: 'string' },
				},
			},
		},
		pledgers: { type: 'number' },
		created: { type: 'string' },
		approved: { type: 'string' },
		favoritesAmount: { type: 'number' },
		projectUrl: { type: 'string' },
		myPledge: { type: 'number' },
		myFavorites: { type: 'number' },
		deliveries: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					videoURL: { type: 'string' },
					timeStamp: { type: 'string' },
					embeddedContent: { type: 'string' },
				},
				required: ['videoURL', 'timeStamp'],
				additionalProperties: true,
			},
		},
		userRejectedDare: { type: 'boolean' },
		expirationDate: { type: 'string' },
	},
	required: [
		'creator',
		'title',
		'description',
		'pledgeAmount',
		'status',
		'games',
		'pledgers',
		'created',
		'favoritesAmount',
		'projectUrl',
		'id',
	],
}
